import type { UiNode, UiNodeInputAttributes } from '@ory/client';

/** 表示順序: hidden inputは最初に配置（フォームに必要だが非表示） */
export const ORDER = 0;

type Props = {
  node: UiNode;
  disabled?: boolean;
};

/**
 * Hidden inputノードコンポーネント
 *
 * Ory KratosのServer Driven UIで返されるhidden inputフィールドをレンダリングします。
 * 主にCSRFトークンなどのセキュリティ関連の値に使用されます。
 *
 * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#hidden-input-node
 */
export function HiddenInput({ node, disabled }: Props) {
  const attrs = node.attributes as UiNodeInputAttributes;

  // hidden inputの場合はtype="hidden"である必要がある
  if (attrs.type !== 'hidden') {
    return null;
  }

  return (
    <input
      type="hidden"
      name={attrs.name}
      value={attrs.value as string}
      disabled={disabled ?? attrs.disabled}
      required={attrs.required}
    />
  );
}
